import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { UtilsModule } from '@bayclubs/utils';
import { DropDownModule } from '@bayclubs/drop-down';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { GcPermissionGuard, InfrastructureModule } from '../infrastructure/infrastructure.module';
import { ManagementContextResolverService, SharedModule } from '../shared/shared.module';
import { ClubCentricReportItemComponent } from './components/club-centric-report/club-centric-report-item/club-centric-report-item.component';
import { ClubCentricReportComponent } from './components/club-centric-report/club-centric-report.component';
import { PayrollReportItemComponent } from './components/payroll-report/payroll-report-item/payroll-report-item.component';
import { PayrollReportComponent } from './components/payroll-report/payroll-report.component';
import { ReportsFilterComponent } from './components/reports-filter/reports-filter.component';
import { ReportsComponent } from './components/reports/reports.component';
import { AttendanceReportComponent } from './components/attendance-report/attendance-report.component';
import { AttendanceReportItemComponent } from './components/attendance-report/attendance-report-item/attendance-report-item.component';
import { InstructorCentricReportComponent } from './components/instructor-centric-report/instructor-centric-report.component';
import { InstructorCentricReportItemComponent } from './components/instructor-centric-report/instructor-centric-report-item/instructor-centric-report-item.component';
import { OnlineContentViewReportComponent } from './containers/online-content-view-report/online-content-view-report.component';
import { OnlineContentViewReportItemComponent } from './components/online-content-view-report/online-content-view-report-item/online-content-view-report-item.component';
import { AdpReportComponent } from './components/adp-report/adp-report.component';
import { AdpReportItemComponent } from './components/adp-report/adp-report-item/adp-report-item.component';


import { OnlineContentViewReportState } from './+state/online-content-view-report.state';
import { dualAuthGuard } from '../core/auth/dual-auth.guard';





const reportsRoutes: Routes = [
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports',
            title: 'NavBarMenu.ReportsMenuItemLabel'
        }
    },
    {
        path: 'payrollReport',
        component: PayrollReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
    {
        path: 'clubCentricReport',
        component: ClubCentricReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
    {
        path: 'attendanceReport',
        component: AttendanceReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
    {
        path: 'instructorCentricReport',
        component: InstructorCentricReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
    {
        path: 'onlineContentViewReport',
        component: OnlineContentViewReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
    {
        path: 'adpReport',
        component: AdpReportComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService
        },
        data: {
            expectedPermission: 'GroupClasses.canViewReports'
        }
    },
];
@NgModule({
    declarations: [
        ReportsComponent,
        ReportsFilterComponent,
        PayrollReportComponent,
        ClubCentricReportComponent,
        ClubCentricReportItemComponent,
        PayrollReportItemComponent,
        AttendanceReportComponent,
        AttendanceReportItemComponent,
        InstructorCentricReportComponent,
        InstructorCentricReportItemComponent,
        OnlineContentViewReportComponent,
        OnlineContentViewReportItemComponent,
        AdpReportComponent,
        AdpReportItemComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        InfrastructureModule,
        UtilsModule,
        ReactiveFormsModule,
        TooltipModule.forRoot(),
        TranslateModule.forChild(),
        RouterModule.forChild(reportsRoutes),
        DropDownModule,
        NgxsModule.forFeature([OnlineContentViewReportState])
    ]
})
export class ReportsModule {}
